<div class="app-mian-header">
  <div class="header-inner">
    <div class="menu-toggle" (click)="toggelSidebar()">
      <img src="assets/images/icons/minimize-sidebar.svg" alt="">
    </div>
    <div class="logo-mobile">
      <img src="./assets/images/logos/logo-sm.svg">
    </div>
    <div class="header-actions">
      <a class="btn btn-lang" (click)="changeLanguage()">
        {{ 'general.language' | translate }}
      </a>
    </div>
    <div class="header-part-right">
      <div class="elementor-widget-container">
        <div class="notification-btn dropdown-container" appDropDown>
          <span (click)="openNotificationPanel()">
            <span class="notification-count">{{ notificationsResult.unSeenNotificationsCount }}</span>
            <img src="./assets/images/icons/notifications-icon.svg"
              [ngClass]="{swing: notificationsResult.unSeenNotificationsCount}">
          </span>
          <div class="notification-panel dropdown-inner-menu">
            <div class="notification-header">
              <h3>{{ 'general.Notification' | translate }}</h3>
            </div>

            <div class="notifications-wrapper">
              <div *ngIf='notifLoading' class="dataLoading py-5">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
              <div [hidden]='notifLoading'>
                <div class="no-data text-center px-2 py-5" *ngIf="!notificationsList.length">
                  {{ 'general.You have no notifications' | translate }}!
                </div>
                <div class="notification-list"
                  *ngIf="notificationsList.length"
                  infiniteScroll
                  [scrollWindow]="false"
                  [infiniteScrollDistance]="2"
                  [infiniteScrollThrottle]="pageCount"
                  (scrolled)="getNextPage()">
                  <div *ngFor="let notif of notificationsList" [ngClass]="{new: !notif.isSeen}" (click)="notificationMenu = false">

                    <ng-container [ngSwitch]="notif.notificationType">
                      <a *ngSwitchCase="'User'" [routerLink]="['/admin/profile']">
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'Restaurant'" [routerLink]="['/admin/restaurants/profile', notif.notificationObjectId]">
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'DiwanRole'" [routerLink]="['/admin/roles']">
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'ReportReviews'" [routerLink]="['/admin/reported-content']"
                        [queryParams]="{ reportId: notif.notificationObjectId }">
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchDefault>
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                    </ng-container>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="elementor-widget-container">
        <div *ngIf="currentUser" class="userAccount dropdown-container m-0" id="userAccountDrop" appDropDown>
          <div class="dropdown-toggler d-flex align-items-center">
            <div class="profile-image">
              <img *ngIf="currentUser.profilePic" [src]="currentUser.profilePic" (error)="currentUser.profilePic = ''" />
              <span *ngIf="!currentUser.profilePic" [innerHTML]="currentUser.fullName | shortName"></span>
            </div>
            <div class="user-name">
              <span class="mr-2"> {{ 'general.Hello' | translate }}, {{currentUser.fullName}}</span>
            </div>
          </div>

          <div class="custom-dropdown-menu dropdown-inner-menu">
            <ul>
              <li><a [routerLink]="['profile']">
                  <svg width="14" height="17" viewBox="0 0 14 17">
                    <path id="my-profile-icon"
                      d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                      fill="#999999" />
                  </svg>{{ 'general.My Profile' | translate }}
                </a></li>
              <li hidden><a [routerLink]="['changepassword']">
                  <svg width="14" height="17" viewBox="0 0 14 17">
                    <path id="my-profile-icon"
                      d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                      fill="#999999" />
                  </svg>{{ 'general.Update password' | translate }}
                </a></li>
              <li>
                <a (click)="logout()">
                  <svg width="17.001" height="17.006" viewBox="0 0 17.001 17.006">
                    <path id="logout-icon"
                      d="M6223.19,12103h-13.4a1.815,1.815,0,0,1-1.8-1.808v-13.383a1.815,1.815,0,0,1,1.811-1.808h13.4a1.817,1.817,0,0,1,1.792,1.808v4.146l-1.659-1.559v-2.74h-13.687v13.575h13.687v-2.625l1.659-1.461v4.165a1.766,1.766,0,0,1-.529,1.267,1.69,1.69,0,0,1-1.123.43C6223.3,12103.006,6223.243,12103,6223.19,12103Zm-4.514-5.039,2.691-2.688h-9.562v-1.54h9.562l-2.691-2.691,1.167-1.169,4.52,4.629-4.52,4.629Z"
                      transform="translate(-6208 -12086)" fill="#999" />
                  </svg>{{ 'general.Logout' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notifContent let-notif="notif">
  <p class="title">{{notif.notificationText}}</p><span class="date">
    {{notif.notificationDate | date:'d MMM, y (h:mm a)'}}
  </span>
</ng-template>
